<template>
  <FullModal ref="FullModal">
    <div class="report-view" v-if="options.row">
      <div class="title">{{ options.row && options.row.name }}</div>
      <VTable
        ref="vtableRef"
        table-code="reportView"
        :loading="loading"
        :columns="columns"
        :data="tableData"
        :contextMenuMap="contextMenuMap"
        :rightFrozenColCount="1"
        :excelFileName="options.row.name"
        @cell-change="handleCellEdit"
        @row-select="handleRowSelect"
        @backspace="handleBackspace"
      />
    </div>
  </FullModal>
</template>

<script>
import FullModal from '@/components/FullModal/index.vue'
import { tableMixin } from '@/utils/tableMixin'
import { dfsFn, listToTree } from '@/utils/index'

export default {
  name: 'ReportView',
  components: { FullModal },
  mixins: [tableMixin],
  data() {
    return {
      options: {},
      columns: [],
      contextMenuMap: {
        查询: () => this.handleSearch(),
        导出: () => this.handleExport()
      },

      loading: false
    }
  },
  methods: {
    // 页面方法
    show(options = {}) {
      this.options = { ...this.options, ...options }
      this.getTableData()
      this.$refs.FullModal.show({
        width: '100%',
        height: '100%',
        title: '',
        showConfirm: false,
        fullscreen: true,
        closeOnPressEscape: false
      })
    },
    async getTableData() {
      this.loading = true

      let res = null
      if (this.options.getData) {
        res = await this.options.getData()
      } else {
        res = await this.$service.post('/costAnalysis/generateReport', {
          projectId: this.options.projectId,
          costAnalysisSettingId: this.options.row?.id
        })
      }

      this.loading = false
      dfsFn(
        res?.data?.columnList.filter((e, i) => i !== 0),
        e => (e.style = { textAlign: 'right' })
      )
      this.columns = res?.data?.columnList || []
      dfsFn(this.columns, e => (e.columns = e.children))
      if (this.columns[0]) this.columns[0].tree = true
      this.tableData = listToTree(res?.data?.dataList || [], -1)
    }
  }
}
</script>

<style scoped lang="less">
.report-view {
  padding-top: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .title {
    color: #000;
    height: 40px;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
